import { Injectable } from '@angular/core';
import { IFnAppSession } from '../../../session/fn-app-session.model';

@Injectable()
export class FnGridGlobalService {
	private postApiUrl: string = '';

	private fnAppSession: IFnAppSession;
	private queryParamHash: any; // HwApiQueryParam;

	setPostApiUrl(apiUrl: string) {
		this.postApiUrl = apiUrl;
	}

	getPostApiUrl() {
		return this.postApiUrl;
	}

	setFnAppSession(fnAppSession: IFnAppSession, queryParamHash: any) {
		this.fnAppSession = fnAppSession;
		this.queryParamHash = queryParamHash;
	}

	getFnAppSession() {
		return this.fnAppSession;
	}

	getQueryParamHash() {
		return this.queryParamHash;
	}
}
